import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

import EnhancedTable from '../../../../../../../../../lib/designSystem/Table';
import EnhancedTab from '../../../../../../../../../lib/designSystem/TabSimulation';
import {
  baseHeaders,
  type CashFlowLine,
  conciliatedHeaders,
  expenseHeaders,
  HeaderConfig,
  incomeHeaders,
  walletHeaders,
} from './utils';

const LinesTable = ({
  data,
  headers,
}: {
  data: CashFlowLine[];
  headers: HeaderConfig[];
}) => (
  <div style={{ overflowX: 'scroll', padding: '8px' }}>
    <EnhancedTable
      dataHeaders={headers}
      data={data}
      exportToFile="xlsx"
      finalSumRow
    />
  </div>
);

interface DayDialogProps {
  row: {
    date: string;
    lines: CashFlowLine[];
  };
  openDialog: boolean;
  handleCloseDialog: () => void;
}

const DayDialog = ({ row, openDialog, handleCloseDialog }: DayDialogProps) => {
  const incomeLines = row?.lines?.filter((line: CashFlowLine) =>
    line.lineTypes.includes('income'),
  );
  const expenseLines = row?.lines?.filter((line: CashFlowLine) =>
    line.lineTypes.includes('expense'),
  );
  const conciliatedLines = row?.lines?.filter((line: CashFlowLine) =>
    line.lineTypes.includes('conciliated'),
  );

  const walletLines = row?.lines?.filter((line: CashFlowLine) =>
    line.lineTypes.includes('wallet'),
  );

  const headersByType = {
    income: [...baseHeaders, ...incomeHeaders],
    expense: [...baseHeaders, ...expenseHeaders],
    conciliated: [...baseHeaders, ...conciliatedHeaders],
    wallet: [...baseHeaders, ...walletHeaders],
  };
  const tabs = [
    {
      label: `Ingresos (${incomeLines?.length || 0})`,
      component: (
        <LinesTable data={incomeLines || []} headers={headersByType.income} />
      ),
      disabled: !incomeLines?.length,
    },
    {
      label: `Costos (${expenseLines?.length || 0})`,
      component: (
        <LinesTable data={expenseLines || []} headers={headersByType.expense} />
      ),
      disabled: !expenseLines?.length,
    },
    {
      label: `Conciliados (${conciliatedLines?.length || 0})`,
      component: (
        <LinesTable
          data={conciliatedLines || []}
          headers={headersByType.conciliated}
        />
      ),
      disabled: !conciliatedLines?.length,
    },
    {
      label: `Cartera (${walletLines?.length || 0})`,
      component: (
        <LinesTable data={walletLines || []} headers={headersByType.wallet} />
      ),
      disabled: !walletLines?.length,
    },
  ];

  const availableTabs = tabs.filter((tab) => !tab.disabled);

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle>Detalles del {row.date}</DialogTitle>
      <DialogContent>
        {availableTabs.length > 0 ? (
          <EnhancedTab
            tabs={availableTabs}
            startValue={0}
            tabType="secondary"
          />
        ) : (
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ padding: '16px' }}
          >
            No hay datos disponibles para mostrar
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DayDialog;
